//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalRedirect',
  data() {
    return {
      isModalOpen: true,
      title: '',
      content: '',
      button_text: '',
      path: '/',
      query: ''
    }
  },
  mounted() {},
  methods: {
    beforeOpen (event) {
      window.dispatchEvent(new Event('resize'));
      this.title = _.get(event, 'params.title', '')
      this.content = _.get(event, 'params.content', '')
      this.button_text = _.get(event, 'params.button_text', '')
      this.path = _.get(event, 'params.path', '')
      this.query = _.get(event, 'params.query', '')
    },
    goToAnClose() {
      this.isModalOpen = false
      if (this.path === 'cashier') {
        this.openCashier('deposit')
      } else {
        this.$router.push({ path: this.localePath(this.path), query: {promotionId: this.query.promotionId}})
      }
    },
    close() {
      this.$modal.hide('modal-redirect')
    },
    async submit() {}
  }
}
